interface VoiceButtonProps {
  isRecording: boolean
  isSpeaking: boolean
  disabled: boolean
  onToggle: () => void
  labels: {
    start: string
    stop: string
    interrupt: string
  }
}

export function VoiceButton({ isRecording, isSpeaking, disabled, onToggle, labels }: VoiceButtonProps) {
  const handleClick = () => {
    onToggle()
  }

  const getStateClass = () => {
    if (isSpeaking) return 'speaking'
    if (isRecording) return 'recording'
    if (disabled) return 'disabled'
    return 'idle'
  }

  return (
    <div className="voice-button-container">
      <button
        className={`voice-button ${getStateClass()}`}
        onClick={handleClick}
        disabled={disabled && !isRecording}
        aria-label={
          isRecording ? labels.stop :
          labels.start
        }
      >
        <div className="voice-button-inner">
          {isRecording ? (
            <svg className="icon-stop" viewBox="0 0 24 24" width="32" height="32">
              <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" />
            </svg>
          ) : (
            <svg className="icon-mic" viewBox="0 0 24 24" width="32" height="32">
              <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5z" fill="currentColor" />
              <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" fill="currentColor" />
            </svg>
          )}
        </div>

        {isRecording && (
          <>
            <div className="pulse-ring ring-1" />
            <div className="pulse-ring ring-2" />
            <div className="pulse-ring ring-3" />
          </>
        )}

        {isSpeaking && (
          <div className="speaking-bars">
            <span /><span /><span /><span /><span />
          </div>
        )}
      </button>
    </div>
  )
}
